export default __webpack_public_path__ + "static/media/bg.7509609f.jpg";